<template>
    <div class="w-100">
        <div class="">
            <b-form-checkbox
                v-model="data.isCheck"
                @input="onCheck()"
                name="checkbox-1"
                value="true"
                unchecked-value="false" >
                <h5 class="label">ประกันคุ้มครองพัสดุ</h5>
            </b-form-checkbox>
            <h5 class="">ข้าพเจ้าได้อ่านและยอมรับเงื่อนไขดังกล่าวแล้ว
                <a :href="urlDocParcelInsurance" target="_blank">เงื่อนไขการคุ้มครองพัสดุ</a>
            </h5>
        </div>
        <div>
            <template v-if="data.isCheck">
                <div>
                    <label for="input-live"><small class="text-danger">*</small> มูลค่าสินค้า</label>
                    <input type="number" class="hide-arrow form-control" 
                        placeholder="คุ้มครองสูงสุดไม่เกิน 50,000 บาท" 
                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                        :class="{ 'is-invalid': error.status }"
                        v-model="data.declared_value"
                        @input="getRate()"/>
                        <template v-if="error.status && error.data.length > 0">
                        <small class="text-danger" 
                            v-for="(msg, index) in error.data" :key="index" >
                            {{msg}}
                        </small>
                        <br />
                    </template>
                    <label for="input-live">ค่าบริการ:  {{data.listPrice.price}} บาท</label>
                </div>
                <div>
                    <label for="input-live">หมายเหตุ</label><br />
                    <label for="input-live" class="flex-nowrap">หากลูกค้ายกเลิกรายการ ก่อนเวลา 16.00 น.ของวันที่สร้างรายการ จะไม่มีการคิดค่าบริการประกันคุ้มครองพัสดุ</label><br />
                    <label>หากลูกค้ายกเลิกรายการ หลังเวลา 16.00 น.ของวันที่สร้างรายการ  จะมีการคิดค่าบริการประกันคุ้มครองพัสดุ เต็มจำนวน</label>
                </div>
            </template>

        </div>
    </div>
</template>
<script>
import insurance from '@/insurances/Insurance'
export default {
    name: "ParcelInsurance",
    data(){
        return {
            urlDocParcelInsurance: 'https://firebasestorage.googleapis.com/v0/b/pop-shippop.appspot.com/o/pdf%2Fparcel_insurance%2Fterms_and_conditions.pdf?alt=media&token=b1b7128e-d40a-4df2-a8ca-b804d40bf42e'
        }
    },
    props: {
        data: Object,
        clear: Function,
        error: Object
    },
    methods:{
        getRate(){
            const _RATES = this.data.listRates[0]
            this.setInsuraceId( _RATES.insurance_id )
            let insClass = new insurance( _RATES.code ).getClass()
            insClass.setRate( _RATES.rates )
            const listPrice = insClass.getPrice( this.data.declared_value )
            if( !listPrice.status ){
                this.data.error.status = true
                this.data.error.msg = listPrice.msg
            }else{
                this.clearError()
            }
            this.setPrice( listPrice.data )
        },
        clearError(){
            this.data.error.status = false
            this.data.error.msg = ""
        },
        setInsuraceId( id ){
            this.data.id = id
            return this.data.id
        },
        setPrice( listPrice ){
            let _DATA = this.data.listPrice
            _DATA.cost = listPrice.cost
            _DATA.rate = listPrice.rate
            _DATA.price = listPrice.price
            return _DATA
        },
        onCheck(){
            const check = this.data.isCheck
            if( !check ){
                this.clear()
            }
        }
    }
    
}
</script>